// test257
(257 && 0);
